import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { Auxilio } from './AuxlioTransporte';
import moment from 'moment';
import { appURL } from '../../../services/auth/jwt/config';
import carteirinhaBackground from '../../../asset/carteirinha_2026.png';

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 10,
    flexDirection: 'column',
  },
  row: {
    flexDirection: 'column',
    justifyContent: 'space-around',
    marginBottom: 10,
  },
  carteiraContainer: {
    width: '100%',
    position: 'relative',
    marginBottom: 10,
  },
  image: {
    width: '100%',
  },
  name: {
    position: 'absolute',
    fontSize: 8,
    left: 120,
    top: 88,
  },
  ensino: {
    position: 'absolute',
    fontSize: 8,
    left: 137,
    top: 130,
  },
  nascimento: {
    position: 'absolute',
    fontSize: 8,
    left: 175,
    top: 116,
  },
  curso: {
    position: 'absolute',
    fontSize: 8,
    left: 60,
    top: 155,
  },
  cpf: {
    position: 'absolute',
    fontSize: 8,
    left: 115,
    top: 101,
  },
  validade: {
    position: 'absolute',
    fontSize: 8,
    left: 178,
    top: 122.7,
  },
  turno: {
    position: 'absolute',
    fontSize: 8,
    left: 214,
    top: 122.7,
  },
  ano: {
    position: 'absolute',
    left: 168,
    top: 148.5,
    fontSize: 8,
    color: '#fff',
    fontWeight: 'bold',
  },
  foto: {
    position: 'absolute',
    left: 16,
    top: 37,
    width: 65,
    height: 75,
    objectFit: 'cover',
  },
});

interface AuxilioCarteiraMultiplaProps {
  data: Auxilio[];
}

const getFotoUrl = (auxilio: Auxilio) => {
  let url = '';
  if (auxilio.anexos) {
    auxilio.anexos.forEach(anexo => {
      if (anexo.tipo_interno === 'foto') {
        url = `${appURL}${anexo.link}`;
      }
    });
  }
  return url;
};

const CarteiraItem = ({ data }: { data: Auxilio }) => {
  return (
    <View style={styles.carteiraContainer}>
      <Image style={styles.image} src={carteirinhaBackground} />
      {/* @ts-ignore */}
      {getFotoUrl(data) ? <Image style={styles.foto} src={getFotoUrl(data)} /> : null}
      <Text style={styles.name}>{data.nome?.toUpperCase()}</Text>
      <Text style={styles.ensino}>{data.instituicao}</Text>
      <Text style={styles.nascimento}>{data.nascimento}</Text>
      <Text style={styles.curso}>{data.curso}</Text>
      <Text style={styles.cpf}>{data.cpf}</Text>
    </View>
  );
};

// Cria o componente do documento com múltiplas carteiras
const AuxilioCarteiraMultipla = ({ data }: AuxilioCarteiraMultiplaProps) => {
  // Divide as carteiras em grupos de 4 (2x2) por página
  const chunkArray = (arr: Auxilio[], size: number) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const pages = chunkArray(data, 4);

  {/* @ts-ignore */ }
  return <Document>
    {pages.map((pageData, pageIndex) => {
      // Divide cada página em linhas de 2 carteiras
      const rows = chunkArray(pageData, 2);
      // @ts-ignore
      return <Page key={pageIndex} size="A4" orientation="portrait" style={styles.page} >
        <View>
          {rows.map((rowData, rowIndex) => (
            <View key={rowIndex} style={styles.row}>
              {rowData.map((auxilio, index) => (
                <CarteiraItem key={auxilio.id || index} data={auxilio} />
              ))}
            </View>
          ))}
        </View>
      </Page>
    })}
  </Document >
};

export default AuxilioCarteiraMultipla;
